import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const icon: ComponentTemplate = {
  id: "2f426eea-2519-4509-bb17-5d300f857c2f",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Basic/Icon",
  leftBarCategory: { main: "basic", subCategory: "shapes" },
  preview: "basic/icon.svg",

  transforms: [],
  template: {
    id: "$uid",
    type: "icon",
    props: {
      iconName: "arrow-right",
      style: {
        width: "24px",
        height: "24px",
      },
    },
  },
};
